import AddIcon from '@mui/icons-material/Add';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TreeItem from '@mui/lab/TreeItem';
import TreeView from '@mui/lab/TreeView';
import { Alert, Box, Container, IconButton, Typography } from '@mui/material';
import axios from "axios";
import React, { useEffect, useState } from 'react';
import GeneralDialog from "../Components/GeneralDialog";
import LoadingSpinnerCentred from "../Components/LoadingSpinnerCentred";

export default function MockExamConfig()
{
    const [mockExams, setMockExams] = useState(null);
    const [alertInfo, setAlertInfo] = useState(null);
    const [dialogInfo, setDialogInfo] = useState(null);

    useEffect(() => fetchMockExamQuestions(), []);

    function fetchMockExamQuestions()
    {
        setMockExams(null);
        axios.get('api/mockexams', { withCredentials: true }).then(result =>
        {
            setMockExams(result.data);
        })
        .catch((error) =>
        {
            setAlertInfo({ type: "error", message: error?.response?.data?.message ?? "An error occured" });
        });
    };

    function showAddMockExamDialog()
    {
        const dialogInfo =
        {
            multiline: "true",
            hasTextEntry: true,
            textFieldTitle: "Question text",
            title: "Add mock exam question",
            actions: [{ handler: (mockExamQuestionText) => onAddMockExam(mockExamQuestionText), text: "Confirm" }]
        };

        setDialogInfo(dialogInfo);
    }

    function onAddMockExam(mockExamQuestionText)
    {
        setDialogInfo(null);
        const dto = { questionText: mockExamQuestionText };
        axios.post('api/mockexams/add', dto, { withCredentials: true }).then(res => {
            fetchMockExamQuestions();
        })
        .catch(error => {
            setAlertInfo({ type: "error", message: error?.response?.data?.message ?? "An error occured" });
        });
    }

    function showDeleteMockExamDialog(event, mockExam)
    {
        event.stopPropagation();

        const dialogInfo =
        {
            title: "Delete mock exam questions",
            text: `Are you sure you want to delete this mock exam question.`,
            actions: [{ handler: () => onDeleteMockExam(mockExam), text: "Confirm" }]
        };

        setDialogInfo(dialogInfo);
    }

    function onDeleteMockExam(mockExam)
    {
        setDialogInfo(null);
        const dto = { id: mockExam.id };
        axios.delete('api/mockexams/delete', { data: dto }, { withCredentials: true }).then(res => {
            fetchMockExamQuestions();
        })
        .catch(error => {
            setAlertInfo({ type: "error", message: error?.response?.data?.message ?? "An error occured" });
        });
    }

    if (!mockExams)
        return <LoadingSpinnerCentred topMargin={true} />

    return (
        <Box>
            <Container maxWidth="sm" sx={{ mt: 8 }}>

                <Typography sx={{ marginTop: 8 }} align="center" component="h1" variant="h4" gutterBottom color="primary">
                    Mock Exam Questions
                </Typography>

                <TreeView defaultCollapseIcon={<ExpandMoreIcon />} defaultExpandIcon={<ChevronRightIcon />}>
                    {mockExams.map((mockExam, index) => (

                        <TreeItem key={index} sx={{ mt: .5, mb: .5 }} nodeId={"pCat" + index} label=
                            {
                                <Box nodeId={index} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography sx={{ fontWeight: 'inherit', flexGrow: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                component="h3"
                                                variant="h6" >
                                      {mockExam.questionText}
                                    </Typography>
                                    <IconButton sx={{ ml: 1 }} edge="end" onClick={(e) => showDeleteMockExamDialog(e, mockExam)} >
                                        <DeleteIcon />
                                    </IconButton>
                                </Box>
                            }>

                            <Typography sx={{ fontWeight: 'inherit', flexGrow: 1 }}  >
                                {mockExam.questionText}
                            </Typography>

                        </TreeItem>
                    ))}

                    <TreeItem sx={{ mt: .5, mb: .5 }} onClick={(e) => showAddMockExamDialog()}
                        nodeId={"addME"} icon={<AddIcon color="primary" fontSize='large' />} label=
                        {
                            <Typography color="primary" display='inline' component="h3" variant="h6" sx={{ mr: 2 }}>
                                Add Mock Exam Question
                            </Typography>
                        }>
                    </TreeItem>

                </TreeView>

                {alertInfo && <Alert sx={{ mt: 2 }} severity={alertInfo.type}>{alertInfo.message}</Alert>}

            </Container>

            {dialogInfo && <GeneralDialog dialogInfo={dialogInfo} setDialogInfo={setDialogInfo} />}
        </Box>
    );
}